import { useMemo } from 'react';

import { GynecologicalInterview } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { createTranslatedText, dateFormatter } from '@dreryk/react-common';
import { LinkSize, SidePanelListItem } from '@dreryk/react-components';

import { GynecologicalInterviewModalOpener, MedicalInformationModalOpenLink } from '~legacy.patient';

import { HistoricalVisitsListItemHeader } from '../../historicalVisits/HistoricalVisitsListItemHeader';

import { GynecologicalInterviewCategoryContent } from './GynecologicalInterviewCategoryContent';

export const useGynecologicalInterviewSidePanelListItems = (
   gynecologicalInterviews: GynecologicalInterview[] | undefined,
   onMedicalDataAccessAuthorizationUpdate: VoidFunction
): SidePanelListItem[] | undefined => {
   return useMemo(() => {
      if (!gynecologicalInterviews) {
         return undefined;
      }
      return gynecologicalInterviews.map((gynecologicalInterview) => ({
         id: gynecologicalInterview.id,
         headerContent: (
            <HistoricalVisitsListItemHeader
               text={createTranslatedText(dateFormatter(gynecologicalInterview.creationDate))}
               icon={
                  <GynecologicalInterviewModalOpener
                     gynecologicalInterview={gynecologicalInterview}
                     onMedicalDataAccessAuthorizationUpdate={onMedicalDataAccessAuthorizationUpdate}
                  >
                     {({ openModal }) => (
                        <MedicalInformationModalOpenLink
                           onClick={openModal}
                           unsignedAttachmentCount={gynecologicalInterview.unsignedAttachmentCount}
                           size={LinkSize.SMALL}
                        />
                     )}
                  </GynecologicalInterviewModalOpener>
               }
            />
         ),
         content: (
            <GynecologicalInterviewModalOpener
               gynecologicalInterview={gynecologicalInterview}
               onMedicalDataAccessAuthorizationUpdate={onMedicalDataAccessAuthorizationUpdate}
            >
               {({ openModal }) => (
                  <GynecologicalInterviewCategoryContent
                     gynecologicalInterview={gynecologicalInterview}
                     onShowMoreAttachmentsClick={openModal}
                  />
               )}
            </GynecologicalInterviewModalOpener>
         ),
      }));
   }, [gynecologicalInterviews, onMedicalDataAccessAuthorizationUpdate]);
};
